/** Lux AbilitySpec seed kit (wiki-aligned numeric batch 1). */
export const LUX_ABILITY_DEFS = [
  {
    id: 'lux_q',
    champKey: 'lux',
    slot: 'Q',
    name: 'Light Binding',
    targeting: 'skillshot_line',
    range: 1300,
    castTime: 0.25,
    travelSpeed: 1200,
    width: 140,
    radius: 70,
    cooldown: 10,
    manaCost: 50,
    vfxId: 'lux_q',
    status: 'wired'
  },
  {
    id: 'lux_w',
    champKey: 'lux',
    slot: 'W',
    name: 'Prismatic Barrier',
    targeting: 'skillshot_line',
    range: 1150,
    castTime: 0.25,
    travelSpeed: 1400,
    width: 220,
    radius: 110,
    cooldown: 12,
    manaCost: 60,
    vfxId: 'lux_w',
    isBoomerang: true,
    status: 'wired'
  },
  {
    id: 'lux_e',
    champKey: 'lux',
    slot: 'E',
    name: 'Lucent Singularity',
    targeting: 'ground_aoe',
    range: 1100,
    castTime: 0.25,
    travelSpeed: 1200,
    width: null,
    radius: 310,
    duration: 5,
    cooldown: 10,
    manaCost: 70,
    vfxId: 'lux_e',
    status: 'wired'
  },
  {
    id: 'lux_r',
    champKey: 'lux',
    slot: 'R',
    name: 'Final Spark',
    targeting: 'skillshot_line',
    range: 3400,
    castTime: 1,
    travelSpeed: null,
    width: 200,
    radius: 100,
    cooldown: 60,
    manaCost: 100,
    vfxId: 'lux_r',
    status: 'wired'
  }
];
